import { SitemapIcon } from './SitemapIcon';

/**
 * author: Simran
 * id 673CE0A7-8AA2-4BFD-9308-B51589FBF520
 * name sitemap
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sitemap.svg
 * tags
 */
export const WorkflowIcon = SitemapIcon;
export default WorkflowIcon